import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import SignetFilter from '../Signet/Filter/SignetFilter';
import SignetList from './SignetList';
import { numberOfItemsPerPage } from '../../constants/globals.js';

const Signet = (props) => {
  const initialStateValues = {
    plannedStartFrom: Date.now(),
    plannedStartTo: Date.now(),
    submitDateFrom: Date.now(),
    submitDateTo: Date.now(),
  };

  const [filters, setFilters] = useState(initialStateValues);
  const [postData, setPostData] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  return (
    <div className="wrapper-fade-in content-min-height mb-5 mt-2">
      <div className="container">
        <SignetFilter
          saveFilters={(filters) => setFilters(filters)}
          initialValues={filters}
          initialStateValues={initialStateValues}
          savePostData={(postData) => setPostData(postData)}
          setResetData={setResetData}
          pageSize={pageSize}
        />
        <SignetList
          postData={postData}
          resetData={resetData}
          setResetData={setResetData}
          activePage={activePage}
          pageSize={pageSize}
          setActivePage={setActivePage}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default withRouter(Signet);
